export const TPA_EXPERIMENTS = {
  USE_BLOCKS_PACKAGE_PICKER_PAGE: 'specs.membership.UseBlocksPackagePickerPage',
  INSTALL_SPLIT_PAGES: 'specs.membership.InstallSplitPages',
  REMOVE_PLAN_LIST_MOBILE_PRESET: 'specs.membership.RemoveMobilePresetPlanCardList',
  INSTALL_ECOM: 'specs.membership.InstallEcom',
  ECOM_INTEGRATION_ENABLED: 'specs.membership.EcomIntegrationEnabled',
  DESIGN_SYSTEM_SETTINGS_MIGRATION: 'specs.membership.DesignSystemSettingsMigration',
  BREAKPOINT_INDICATORS_OOI: 'specs.membership.breakpointIndicatorsOOI',
  ADD_PLAN_COVER_IMAGE: 'specs.membership.AddPlanCoverImage',
  RENDER_PLAN_COVER_IMAGE: 'specs.membership.RenderPlanCoverImage',
  SKIP_ADDITIONAL_INFO_ON_EMPTY_FORM: 'specs.membership.skipAdditionalInfoIfEmptyForm',
  BENEFIT_PROGRAMS_ENABLED: 'specs.membership.BenefitProgramsEnabled',
  CHECKOUT_NAVIGATION_IMPROVEMENTS: 'specs.membership.CheckoutNavigationImprovements'
};
//# sourceMappingURL=tpa.js.map